import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CommonService} from '../../@shared/services/common.service';
import {CacheService} from '../../@shared/services/cache.service';


@Component({
    selector: 'user-roles',
    templateUrl: './user-roles.component.html',
    styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit {
    @Output() applyFilter: EventEmitter<any> = new EventEmitter<any>();
    shippingRoles: string[];
    selectedShippingRoles: any[] = this.cacheService.retrieveParsedResponse('selected-role');

    constructor(private cacheService: CacheService, private commonService: CommonService) {
        // @ts-ignore
        this.shippingRoles = [];
    }

    ngOnInit(): void {
        this.getShipmentRoles();
    }

    onClickUpdateRoles(roles) {
        this.selectedShippingRoles?.push(roles);
        this.applyFilter.emit({
            roles,
            event: 'close'
        });
    }

    getShipmentRoles() {
        this.commonService
            .getShipmentRoles()
            .subscribe(
                (x) => {
                    this.shippingRoles = x;
                    // this.shippingRoles = ['Tufe;', 'Akib', 'Ajmal', 'Akib', 'card', 'card', 'card', 'card', 'card'];
                }
            );
    }

    storeSelectedShippingRoles($event: any) {
        console.log('Selected Roles : ', this.selectedShippingRoles);
    }
}
